import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import ArticlePage from "@/pages/artigo/cssbuy-spreadsheet-guia-completo/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/artigo/:slug",
    element: <ArticlePage />,
  },
  {
    path: "/en",
    element: <Home />,
  },
  {
    path: "/de",
    element: <Home />,
  },
  {
    path: "/categorias",
    element: <Home />,
  },
  {
    path: "/guias",
    element: <Home />,
  },
  {
    path: "/qc",
    element: <Home />,
  },
  {
    path: "/envio",
    element: <Home />,
  },
  {
    path: "/comparacoes",
    element: <Home />,
  },
  {
    path: "/seguranca",
    element: <Home />,
  },
  {
    path: "/sobre",
    element: <Home />,
  },
  {
    path: "/editorial-policy",
    element: <Home />,
  },
  {
    path: "/contato",
    element: <Home />,
  },
  {
    path: "/privacy",
    element: <Home />,
  },
  {
    path: "/terms",
    element: <Home />,
  },
  {
    path: "/disclaimer",
    element: <Home />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;